import { CustomerLiteModel } from 'api-hooks/customer';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { GuestModel } from 'api-hooks/guest';
import { SaleModel } from 'api-hooks/sale/common';
import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

import { TourFlightAirlinesModel } from '../tour-list/flight/model';
import { TourLiteModel, TourPriceModel } from '../tour-list/tour-detail';

export enum bedTypeEnum {
  single = 'single',
  double = 'double',
  twin = 'twin',
  king = 'king',
  queen = 'queen',
}

export class TourOtherPriceModel {
  id: string;
  description: string;
  price: string;
}

export class TourFLightModel {
  id: string;
  name: string;
  note: string;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'tour_flight_airlines' })
  @Type(() => TourFlightAirlinesModel)
  tourFlightAirlines: TourFlightAirlinesModel[];
}

export class PriceModel {
  id: string;
  type: string;

  @Expose({ name: 'ref_id' })
  refId: string;
}

export class TourSaleAddOnsModel {
  id: string;
  description: string;

  @Type(() => Number)
  price: number;

  @Expose({ name: 'guest' })
  @Type(() => GuestModel)
  guest: GuestModel;
}

export class TourSaleGuestModel {
  id: string;
  type: string;
  note: string;

  @Expose({ name: 'guest_name' })
  guestName: string;

  @Expose({ name: 'flight_name' })
  flightName: string;

  @Type(() => Number)
  price: number;

  @Expose({ name: 'guest' })
  @Type(() => GuestModel)
  guest: GuestModel;

  @Expose({ name: 'bed_type' })
  bedType: string;

  @Expose({ name: 'group_number' })
  groupNumber: string;

  @Expose({ name: 'tour_flight' })
  @Type(() => TourFLightModel)
  tourFlight: TourFLightModel;

  @Expose({ name: 'tour_price' })
  @Type(() => PriceModel)
  tourPrice: PriceModel;
}

export class TourSaleOtherPrices {
  id: string;
  description: string;

  @Type(() => Number)
  qty: number;

  @Type(() => Number)
  total: number;

  @Type(() => Number)
  price: number;

  @Expose({ name: 'tour_other_price' })
  @Type(() => TourOtherPriceModel)
  tourOtherPrice: TourOtherPriceModel;
}

export class TourSaleItemModel {
  id: string;

  @Type(() => TourLiteModel)
  tour?: TourLiteModel;

  @Expose({ name: 'tour_sale_guests' })
  @Type(() => TourSaleGuestModel)
  tourSaleGuests: TourSaleGuestModel[];

  @Expose({ name: 'tour_sale_add_ons' })
  @Type(() => TourSaleAddOnsModel)
  tourSaleAddOns: TourSaleAddOnsModel[];

  @Expose({ name: 'tour_sale_other_prices' })
  @Type(() => TourSaleOtherPrices)
  tourSaleOtherPrices: TourSaleOtherPrices[];
}

export class CustomerBillingModel {
  id: string;
  phone: string;
  address: string;
}

export class TourSaleLiteModel extends CommonModel {
  code: string;
  visa: string;
  status: string;
  guests: string[];

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;

  @Type(() => TourSaleItemModel)
  tourParticipant: TourSaleItemModel;

  @Expose({ name: 'invoice_number' })
  invoiceNumber: string;

  @Expose({ name: 'billing_address' })
  @Type(() => CustomerBillingModel)
  billingAddress: CustomerBillingModel | null;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => Number)
  total: number;

  @Type(() => CustomerLiteModel)
  customer: CustomerLiteModel;

  @Type(() => EmployeeLiteModel)
  admin: EmployeeLiteModel;

  @Type(() => EmployeeLiteModel)
  operator: EmployeeLiteModel | null;

  @Type(() => EmployeeLiteModel)
  salesman: EmployeeLiteModel | null;

  @Expose({ name: 'payment_status' })
  paymentStatus: string;

  @Expose({ name: 'is_completed' })
  @Type(() => Boolean)
  isCompleted: boolean;
}

export class TourSalesModel extends SaleModel {
  @Expose({ name: 'tour_ref_id' })
  tourRefId: string;

  @Expose({ name: 'tour_sales' })
  @Type(() => TourSaleItemModel)
  tourSales: TourSaleItemModel[];
}

export class TourDetailModel extends CommonModel {
  code: string;
  description: string;
  name: string;
  status: string;
  type: string;

  @Expose({ name: 'ended_at' })
  @Type(() => Date)
  endedAt: Date;

  @Expose({ name: 'started_at' })
  @Type(() => Date)
  startedAt: Date;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => Number)
  day: number;

  @Expose({ name: 'ref_id' })
  refId: string;
}
export class TourSaleDetailGuestModel extends CommonModel {
  note: string;
  status: string;

  @Expose({ name: 'bed_type' })
  bedType: string;

  @Expose({ name: 'group_number' })
  groupNumber: string;

  @Type(() => GuestModel)
  guest: GuestModel;

  @Type(() => Number)
  price: number;

  @Expose({ name: 'tour_flight' })
  @Type(() => TourFLightModel)
  tourFlight: TourFLightModel | null;

  @Expose({ name: 'tour_price' })
  @Type(() => TourPriceModel)
  tourPrice: TourPriceModel | null;
}

export class TourSaleDetailAddOnsModel extends CommonModel {
  description: string;
  status: string;

  @Type(() => Number)
  price: number;

  @Type(() => GuestModel)
  guest: GuestModel;
}

export class TourSaleDetailModel extends CommonModel {
  @Type(() => TourDetailModel)
  tour: TourDetailModel;

  @Expose({ name: 'tour_sale_guests' })
  @Type(() => TourSaleDetailGuestModel)
  tourSaleGuests: TourSaleDetailGuestModel[];

  @Expose({ name: 'tour_sale_add_ons' })
  @Type(() => TourSaleDetailAddOnsModel)
  tourSaleAddOns: TourSaleDetailAddOnsModel[];
}

export class getTourSalesInput {
  params: CommonParamInput;
}

export class getTourSaleInput {
  id: string;
}

export class TourSaleTourGuestInput {
  id?: string;
  tourPriceRefId: string;
  tourFlightRefId: string;
  bedType: string;
  groupNumber: string;
  price: number;
  note: string;
  guestId: string;
}

export class TourSaleAddOnsInput {
  id?: string;
  guestId: string;
  description: string;
  price: number;
}

export class TourSaleItemInput {
  id?: string;
  tourSaleGuests: TourSaleTourGuestInput[];
  tourSaleAddOns: TourSaleAddOnsInput[];
}
export class TourSaleMutationInput {
  transactionAt?: Date | null;
  needApproval: boolean;
  code: string;
  tourId: string;
  adminId: string;
  operatorId: string;
  salesmanId: string;
  customerId: string;
  customerBillingId: string;
  tourSales: TourSaleItemInput[];
  discount: number;
  otherCost: number;
  description: string;
  total: number;
  invoiceNumber?: string;
}

export class TourSaleUpdateInput {
  tourSaleId: string;
  body: TourSaleMutationInput;
}

export class TourSaleDeleteInput {
  id: string;
}
